import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders
} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { AuthService } from './auth/auth.service';
import { tap, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

  constructor(
    public auth: AuthService,
    private readonly router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const headersNew = new HttpHeaders();
    let authorizedRequest = req.clone();

    if (isPlatformBrowser(this.platformId)) {
      if (this.auth.isAuthenticated() && !req.url.includes('googleapis') && !req.url.includes('rappi')) {
        authorizedRequest = req.clone({
          headers: headersNew.append('Authorization', `Bearer ${localStorage.getItem('token') ?? ''}`),
        });
      }
    }

    return next.handle(authorizedRequest).pipe(
      tap((event: any) => {}),
      catchError((err: any, caught: Observable<any>) => {
        if (err?.status == 401) {
          // this.router.navigate(['/auth']);
        }

        return throwError(err);
      })
    );

  }

}
